// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1TFaF","infoBtn":"quickbooks_infoBtn__3DB2D","formBox":"quickbooks_formBox__1SMUz","formFooter":"quickbooks_formFooter__1Qkk0"};